import React from 'react';

import {formatTypedValue} from 'notebook/tables/typed-values/DataTypes';
import {BaseTypedValueType, TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';
import BenchChip from 'ui-library/chips/BenchChip';
import Chip, {ChipSize} from 'ui-library/chips/Chip';
import {FolderItemIcon} from 'ui-library/icons/IconConstants';

interface BulkAssemblyPrimerProps {
  typedValue: TypedValue;
}

/**
 * Show bulk assembly primers as chips.
 *
 * - Existing oligos render as linked bioentity chips.
 * - Primers that have a name and are yet to be created render as non-interactive chips.
 * - Primers without names will not exist and render as an empty cell.
 */
export default function BulkAssemblyPrimer({typedValue}: BulkAssemblyPrimerProps): JSX.Element | null {
  if (typedValue.type === BaseTypedValueType.BIOENTITY) {
    return <BenchChip id={typedValue.bioentitySummary.id} size={ChipSize.TABLE_CELL} />;
  }
  const primerName = formatTypedValue(typedValue);
  if (primerName.length > 0) {
    return <Chip text={primerName} icon={FolderItemIcon.OligoV2} size={ChipSize.TABLE_CELL} />;
  }
  return null;
}
